var map = {
	"./central-hospital/pic_0.jpg": "a0a0",
	"./central-hospital/pic_1.jpg": "91d6",
	"./central-hospital/pic_10.jpg": "2261",
	"./central-hospital/pic_11.jpg": "3b3d",
	"./central-hospital/pic_12.jpg": "a671",
	"./central-hospital/pic_13.jpg": "d0c6",
	"./central-hospital/pic_14.jpg": "faa9",
	"./central-hospital/pic_15.jpg": "f2b9",
	"./central-hospital/pic_16.jpg": "f9a4",
	"./central-hospital/pic_17.jpg": "60ff",
	"./central-hospital/pic_2.jpg": "b598",
	"./central-hospital/pic_3.jpg": "b5b6",
	"./central-hospital/pic_4.jpg": "4ea4",
	"./central-hospital/pic_5.jpg": "f0e0",
	"./central-hospital/pic_6.jpg": "a339",
	"./central-hospital/pic_7.jpg": "2160",
	"./central-hospital/pic_8.jpg": "18e6",
	"./central-hospital/pic_9.jpg": "52b0",
	"./cherkasy-dispensary/pic_0.jpg": "ab56",
	"./cherkasy-dispensary/pic_1.jpg": "3ff1",
	"./cherkasy-dispensary/pic_10.jpg": "c044",
	"./cherkasy-dispensary/pic_11.jpg": "0604",
	"./cherkasy-dispensary/pic_12.jpg": "3162",
	"./cherkasy-dispensary/pic_2.jpg": "baeb",
	"./cherkasy-dispensary/pic_3.jpg": "4486",
	"./cherkasy-dispensary/pic_4.jpg": "dbba",
	"./cherkasy-dispensary/pic_5.jpg": "77c7",
	"./cherkasy-dispensary/pic_6.jpg": "62c7",
	"./cherkasy-dispensary/pic_7.jpg": "3e9a",
	"./cherkasy-dispensary/pic_8.jpg": "1545a",
	"./cherkasy-dispensary/pic_9.jpg": "8ff8",
	"./chernihiv-city-second/pic_0.jpg": "3ff5",
	"./chernihiv-city-second/pic_1.jpg": "7c24",
	"./chernihiv-city-second/pic_10.jpg": "17c9",
	"./chernihiv-city-second/pic_11.jpg": "187b",
	"./chernihiv-city-second/pic_12.jpg": "4967",
	"./chernihiv-city-second/pic_13.jpg": "15b6",
	"./chernihiv-city-second/pic_2.jpg": "1840",
	"./chernihiv-city-second/pic_3.jpg": "93d9",
	"./chernihiv-city-second/pic_4.jpg": "e7ea",
	"./chernihiv-city-second/pic_5.jpg": "cef1",
	"./chernihiv-city-second/pic_6.jpg": "6b52",
	"./chernihiv-city-second/pic_7.jpg": "2612",
	"./chernihiv-city-second/pic_8.jpg": "165c",
	"./chernihiv-city-second/pic_9.jpg": "a4dd",
	"./chernihiv-five/pic_0.jpg": "3af2",
	"./chernihiv-five/pic_1.jpg": "9587",
	"./chernihiv-five/pic_10.jpg": "6e8d",
	"./chernihiv-five/pic_11.jpg": "e602",
	"./chernihiv-five/pic_12.jpg": "ea4f",
	"./chernihiv-five/pic_13.jpg": "7004",
	"./chernihiv-five/pic_14.jpg": "5e58",
	"./chernihiv-five/pic_15.jpg": "c3f7",
	"./chernihiv-five/pic_16.jpg": "2f54",
	"./chernihiv-five/pic_17.jpg": "092d",
	"./chernihiv-five/pic_18.jpg": "fb38",
	"./chernihiv-five/pic_19.jpg": "82e6",
	"./chernihiv-five/pic_2.jpg": "026e",
	"./chernihiv-five/pic_3.jpg": "26dd",
	"./chernihiv-five/pic_4.jpg": "5bea",
	"./chernihiv-five/pic_5.jpg": "3a5c",
	"./chernihiv-five/pic_6.jpg": "389b",
	"./chernihiv-five/pic_7.jpg": "5634",
	"./chernihiv-five/pic_8.jpg": "0578",
	"./chernihiv-five/pic_9.jpg": "9087",
	"./chernihiv-fourth/pic_0.jpg": "ffeb",
	"./chernihiv-fourth/pic_1.jpg": "75f5",
	"./chernihiv-fourth/pic_10.jpg": "642c",
	"./chernihiv-fourth/pic_11.jpg": "7010",
	"./chernihiv-fourth/pic_12.jpg": "a7fb",
	"./chernihiv-fourth/pic_13.jpg": "4fde",
	"./chernihiv-fourth/pic_14.jpg": "e579",
	"./chernihiv-fourth/pic_2.jpg": "7cd1",
	"./chernihiv-fourth/pic_3.jpg": "d9c8",
	"./chernihiv-fourth/pic_4.jpg": "f780",
	"./chernihiv-fourth/pic_5.jpg": "a8bb",
	"./chernihiv-fourth/pic_6.jpg": "6e15",
	"./chernihiv-fourth/pic_7.jpg": "3903",
	"./chernihiv-fourth/pic_8.jpg": "ded8",
	"./chernihiv-fourth/pic_9.jpg": "ce46",
	"./chernihiv-hospital/pic_0.jpg": "904a",
	"./chernihiv-hospital/pic_1.jpg": "a388",
	"./chernihiv-hospital/pic_10.jpg": "e6cf",
	"./chernihiv-hospital/pic_11.jpg": "f086",
	"./chernihiv-hospital/pic_12.jpg": "74b2",
	"./chernihiv-hospital/pic_13.jpg": "6ccd",
	"./chernihiv-hospital/pic_2.jpg": "11da",
	"./chernihiv-hospital/pic_3.jpg": "53d1",
	"./chernihiv-hospital/pic_4.jpg": "e21d",
	"./chernihiv-hospital/pic_5.jpg": "719d",
	"./chernihiv-hospital/pic_6.jpg": "a213",
	"./chernihiv-hospital/pic_7.jpg": "651b",
	"./chernihiv-hospital/pic_8.jpg": "f241",
	"./chernihiv-hospital/pic_9.jpg": "6375",
	"./chernihiv-hospital_wrong/pic_0.jpg": "c3e5",
	"./chernihiv-hospital_wrong/pic_1.jpg": "39db",
	"./chernihiv-hospital_wrong/pic_10.jpg": "3f47",
	"./chernihiv-hospital_wrong/pic_11.jpg": "0144",
	"./chernihiv-hospital_wrong/pic_12.jpg": "8ef4",
	"./chernihiv-hospital_wrong/pic_13.jpg": "73bd",
	"./chernihiv-hospital_wrong/pic_14.jpg": "ca9c",
	"./chernihiv-hospital_wrong/pic_15.jpg": "3b70",
	"./chernihiv-hospital_wrong/pic_16.jpg": "fa6a",
	"./chernihiv-hospital_wrong/pic_17.jpg": "d0a5",
	"./chernihiv-hospital_wrong/pic_18.jpg": "78f3",
	"./chernihiv-hospital_wrong/pic_19.jpg": "5632",
	"./chernihiv-hospital_wrong/pic_2.jpg": "654f",
	"./chernihiv-hospital_wrong/pic_20.jpg": "7de7",
	"./chernihiv-hospital_wrong/pic_3.jpg": "2fc0",
	"./chernihiv-hospital_wrong/pic_4.jpg": "16d8",
	"./chernihiv-hospital_wrong/pic_5.jpg": "6079",
	"./chernihiv-hospital_wrong/pic_6.jpg": "bec8",
	"./chernihiv-hospital_wrong/pic_7.jpg": "0f06",
	"./chernihiv-hospital_wrong/pic_8.jpg": "9c95",
	"./chernihiv-hospital_wrong/pic_9.jpg": "75a6",
	"./chernihiv-third/pic_0.jpg": "7310",
	"./chernihiv-third/pic_1.jpg": "37c8",
	"./chernihiv-third/pic_10.jpg": "a4b9",
	"./chernihiv-third/pic_11.jpg": "88dc",
	"./chernihiv-third/pic_12.jpg": "5ce9",
	"./chernihiv-third/pic_13.jpg": "d23a",
	"./chernihiv-third/pic_14.jpg": "270a",
	"./chernihiv-third/pic_15.jpg": "9ed4",
	"./chernihiv-third/pic_16.jpg": "0089",
	"./chernihiv-third/pic_17.jpg": "5fe1",
	"./chernihiv-third/pic_18.jpg": "ff74",
	"./chernihiv-third/pic_19.jpg": "5cd5",
	"./chernihiv-third/pic_2.jpg": "d7f2",
	"./chernihiv-third/pic_20.jpg": "29fc",
	"./chernihiv-third/pic_3.jpg": "8612",
	"./chernihiv-third/pic_4.jpg": "a9c7",
	"./chernihiv-third/pic_5.jpg": "4507",
	"./chernihiv-third/pic_6.jpg": "2b90",
	"./chernihiv-third/pic_7.jpg": "90ca",
	"./chernihiv-third/pic_8.jpg": "fe3b",
	"./chernihiv-third/pic_9.jpg": "def9",
	"./children-center/pic_0.jpg": "7c2b",
	"./children-center/pic_1.jpg": "263a",
	"./children-center/pic_10.jpg": "2ca7",
	"./children-center/pic_11.jpg": "5af0",
	"./children-center/pic_12.jpg": "77c4",
	"./children-center/pic_13.jpg": "4e4f",
	"./children-center/pic_14.jpg": "5854",
	"./children-center/pic_15.jpg": "e87b",
	"./children-center/pic_16.jpg": "cb08",
	"./children-center/pic_17.jpg": "479c",
	"./children-center/pic_18.jpg": "91f3",
	"./children-center/pic_19.jpg": "9722",
	"./children-center/pic_2.jpg": "e640",
	"./children-center/pic_20.jpg": "16d0",
	"./children-center/pic_3.jpg": "9f2e",
	"./children-center/pic_4.jpg": "aa85",
	"./children-center/pic_5.jpg": "1ced",
	"./children-center/pic_6.jpg": "dceb",
	"./children-center/pic_7.jpg": "1ca0",
	"./children-center/pic_8.jpg": "acd8",
	"./children-center/pic_9.jpg": "4134",
	"./children-clinic/pic_0.jpg": "9a02",
	"./children-clinic/pic_1.jpg": "8c71",
	"./children-clinic/pic_10.jpg": "ee28",
	"./children-clinic/pic_11.jpg": "c177",
	"./children-clinic/pic_12.jpg": "e1c2",
	"./children-clinic/pic_13.jpg": "3738",
	"./children-clinic/pic_14.jpg": "cc3b",
	"./children-clinic/pic_15.jpg": "1d13",
	"./children-clinic/pic_16.jpg": "2ed8",
	"./children-clinic/pic_17.jpg": "93ea",
	"./children-clinic/pic_18.jpg": "6262",
	"./children-clinic/pic_19.jpg": "d4ea",
	"./children-clinic/pic_2.jpg": "565f",
	"./children-clinic/pic_20.jpg": "90b7",
	"./children-clinic/pic_3.jpg": "1e93",
	"./children-clinic/pic_4.jpg": "a34f",
	"./children-clinic/pic_5.jpg": "e467",
	"./children-clinic/pic_6.jpg": "c874",
	"./children-clinic/pic_7.jpg": "94bc",
	"./children-clinic/pic_8.jpg": "63aa",
	"./children-clinic/pic_9.jpg": "c758",
	"./children-polyclinic/pic_0.jpg": "d210",
	"./children-polyclinic/pic_1.jpg": "5736",
	"./children-polyclinic/pic_10.jpg": "96d5",
	"./children-polyclinic/pic_11.jpg": "c04d",
	"./children-polyclinic/pic_12.jpg": "d09d",
	"./children-polyclinic/pic_13.jpg": "8354",
	"./children-polyclinic/pic_14.jpg": "7de5",
	"./children-polyclinic/pic_15.jpg": "4539",
	"./children-polyclinic/pic_16.jpg": "380e",
	"./children-polyclinic/pic_2.jpg": "23c9",
	"./children-polyclinic/pic_3.jpg": "4ea9",
	"./children-polyclinic/pic_4.jpg": "5a66",
	"./children-polyclinic/pic_5.jpg": "0641",
	"./children-polyclinic/pic_6.jpg": "4222",
	"./children-polyclinic/pic_7.jpg": "8b29",
	"./children-polyclinic/pic_8.jpg": "d06f",
	"./children-polyclinic/pic_9.jpg": "61f5",
	"./children-regional/pic_0.jpg": "6136",
	"./children-regional/pic_1.jpg": "8471",
	"./children-regional/pic_10.jpg": "6498",
	"./children-regional/pic_11.jpg": "0724",
	"./children-regional/pic_12.jpg": "d504",
	"./children-regional/pic_13.jpg": "bd2e",
	"./children-regional/pic_14.jpg": "327d",
	"./children-regional/pic_15.jpg": "db54",
	"./children-regional/pic_16.jpg": "278b",
	"./children-regional/pic_17.jpg": "3af1",
	"./children-regional/pic_2.jpg": "2150",
	"./children-regional/pic_3.jpg": "e51b",
	"./children-regional/pic_4.jpg": "535e",
	"./children-regional/pic_5.jpg": "1138",
	"./children-regional/pic_6.jpg": "cee5",
	"./children-regional/pic_7.jpg": "a688",
	"./children-regional/pic_8.jpg": "558a",
	"./children-regional/pic_9.jpg": "a289",
	"./childrens-hospital/pic_0.jpg": "c8bc",
	"./childrens-hospital/pic_1.jpg": "fd48",
	"./childrens-hospital/pic_10.jpg": "7027",
	"./childrens-hospital/pic_11.jpg": "8e1d",
	"./childrens-hospital/pic_12.jpg": "641e",
	"./childrens-hospital/pic_13.jpg": "1f0a",
	"./childrens-hospital/pic_14.jpg": "f99b",
	"./childrens-hospital/pic_15.jpg": "51ad",
	"./childrens-hospital/pic_16.jpg": "a54a",
	"./childrens-hospital/pic_2.jpg": "ab40",
	"./childrens-hospital/pic_3.jpg": "0be5",
	"./childrens-hospital/pic_4.jpg": "2914",
	"./childrens-hospital/pic_5.jpg": "cdca",
	"./childrens-hospital/pic_6.jpg": "f527",
	"./childrens-hospital/pic_7.jpg": "3ed0",
	"./childrens-hospital/pic_8.jpg": "4b00",
	"./childrens-hospital/pic_9.jpg": "8f5f",
	"./city-clinic/pic_0.jpg": "7cde",
	"./city-clinic/pic_1.jpg": "558aa",
	"./city-clinic/pic_10.jpg": "2eb9",
	"./city-clinic/pic_11.jpg": "a389",
	"./city-clinic/pic_2.jpg": "c5f9",
	"./city-clinic/pic_3.jpg": "fe6a",
	"./city-clinic/pic_4.jpg": "4efa",
	"./city-clinic/pic_5.jpg": "9051",
	"./city-clinic/pic_6.jpg": "3b1f",
	"./city-clinic/pic_7.jpg": "b5b5",
	"./city-clinic/pic_8.jpg": "2ea5",
	"./city-clinic/pic_9.jpg": "eebe",
	"./city-hospital/pic_0.jpg": "a2a4",
	"./city-hospital/pic_1.jpg": "2f63",
	"./city-hospital/pic_10.jpg": "fe22",
	"./city-hospital/pic_11.jpg": "2a58",
	"./city-hospital/pic_12.jpg": "b03a",
	"./city-hospital/pic_13.jpg": "a9fb",
	"./city-hospital/pic_14.jpg": "a19d",
	"./city-hospital/pic_15.jpg": "bda0",
	"./city-hospital/pic_16.jpg": "4c09",
	"./city-hospital/pic_2.jpg": "073e",
	"./city-hospital/pic_3.jpg": "c8d1",
	"./city-hospital/pic_4.jpg": "b0da",
	"./city-hospital/pic_5.jpg": "d014",
	"./city-hospital/pic_6.jpg": "4e80",
	"./city-hospital/pic_7.jpg": "9db8",
	"./city-hospital/pic_8.jpg": "1734",
	"./city-hospital/pic_9.jpg": "fa23",
	"./city-polyclinic/pic_0.jpg": "9689",
	"./city-polyclinic/pic_1.jpg": "e2ad",
	"./city-polyclinic/pic_10.jpg": "8f38",
	"./city-polyclinic/pic_11.jpg": "39c1",
	"./city-polyclinic/pic_12.jpg": "9b5e",
	"./city-polyclinic/pic_13.jpg": "973c",
	"./city-polyclinic/pic_14.jpg": "b07e",
	"./city-polyclinic/pic_15.jpg": "9b4a",
	"./city-polyclinic/pic_16.jpg": "9db9",
	"./city-polyclinic/pic_17.jpg": "177a",
	"./city-polyclinic/pic_18.jpg": "c9de",
	"./city-polyclinic/pic_19.jpg": "6f61",
	"./city-polyclinic/pic_2.jpg": "f7a9",
	"./city-polyclinic/pic_20.jpg": "e067",
	"./city-polyclinic/pic_3.jpg": "4e79",
	"./city-polyclinic/pic_4.jpg": "bff8",
	"./city-polyclinic/pic_5.jpg": "3182",
	"./city-polyclinic/pic_6.jpg": "a802",
	"./city-polyclinic/pic_7.jpg": "0ca8",
	"./city-polyclinic/pic_8.jpg": "c3e1",
	"./city-polyclinic/pic_9.jpg": "f9d0",
	"./eight-hospital/pic_0.jpg": "2433",
	"./eight-hospital/pic_1.jpg": "f5f2",
	"./eight-hospital/pic_10.jpg": "76c7",
	"./eight-hospital/pic_11.jpg": "cc87",
	"./eight-hospital/pic_2.jpg": "a5fd",
	"./eight-hospital/pic_3.jpg": "c82b",
	"./eight-hospital/pic_4.jpg": "957e",
	"./eight-hospital/pic_5.jpg": "88f4",
	"./eight-hospital/pic_6.jpg": "77a8",
	"./eight-hospital/pic_7.jpg": "fa47",
	"./eight-hospital/pic_8.jpg": "e34a",
	"./eight-hospital/pic_9.jpg": "4aef",
	"./family-hospital/pic_0.jpg": "6dac",
	"./family-hospital/pic_1.jpg": "46c3",
	"./family-hospital/pic_10.jpg": "4dce",
	"./family-hospital/pic_11.jpg": "e2de",
	"./family-hospital/pic_12.jpg": "8ed1",
	"./family-hospital/pic_13.jpg": "a202",
	"./family-hospital/pic_14.jpg": "d80a",
	"./family-hospital/pic_15.jpg": "c9ea",
	"./family-hospital/pic_16.jpg": "33cb",
	"./family-hospital/pic_17.jpg": "1ab5",
	"./family-hospital/pic_2.jpg": "8e09",
	"./family-hospital/pic_3.jpg": "cbc8",
	"./family-hospital/pic_4.jpg": "33b8",
	"./family-hospital/pic_5.jpg": "3176",
	"./family-hospital/pic_6.jpg": "0bdf",
	"./family-hospital/pic_7.jpg": "44a34",
	"./family-hospital/pic_8.jpg": "d00b",
	"./family-hospital/pic_9.jpg": "c3a9",
	"./first-cherkasy/pic_0.jpg": "6972",
	"./first-cherkasy/pic_1.jpg": "34f7",
	"./first-cherkasy/pic_10.jpg": "e4c2",
	"./first-cherkasy/pic_11.jpg": "6479",
	"./first-cherkasy/pic_12.jpg": "61f4",
	"./first-cherkasy/pic_13.jpg": "6605",
	"./first-cherkasy/pic_14.jpg": "5240",
	"./first-cherkasy/pic_15.jpg": "87f6",
	"./first-cherkasy/pic_16.jpg": "a4ba",
	"./first-cherkasy/pic_17.jpg": "c2c3",
	"./first-cherkasy/pic_18.jpg": "b14e",
	"./first-cherkasy/pic_2.jpg": "fdc2",
	"./first-cherkasy/pic_3.jpg": "344e",
	"./first-cherkasy/pic_4.jpg": "aad3",
	"./first-cherkasy/pic_5.jpg": "d080",
	"./first-cherkasy/pic_6.jpg": "cb48",
	"./first-cherkasy/pic_7.jpg": "9b5d",
	"./first-cherkasy/pic_8.jpg": "0126",
	"./first-cherkasy/pic_9.jpg": "26f4",
	"./fourth-lviv/pic_0.jpg": "65c8",
	"./fourth-lviv/pic_1.jpg": "e320",
	"./fourth-lviv/pic_10.jpg": "eff8",
	"./fourth-lviv/pic_11.jpg": "eda8",
	"./fourth-lviv/pic_12.jpg": "ab21",
	"./fourth-lviv/pic_13.jpg": "1787",
	"./fourth-lviv/pic_14.jpg": "3358",
	"./fourth-lviv/pic_15.jpg": "a254",
	"./fourth-lviv/pic_16.jpg": "5a3f",
	"./fourth-lviv/pic_2.jpg": "e5b3",
	"./fourth-lviv/pic_3.jpg": "b6f4",
	"./fourth-lviv/pic_4.jpg": "2d0e",
	"./fourth-lviv/pic_5.jpg": "1490",
	"./fourth-lviv/pic_6.jpg": "4b4b",
	"./fourth-lviv/pic_7.jpg": "d058",
	"./fourth-lviv/pic_8.jpg": "9c0a",
	"./fourth-lviv/pic_9.jpg": "d7c0",
	"./gynecology-association/pic_0.jpg": "b6b1",
	"./gynecology-association/pic_1.jpg": "aac5",
	"./gynecology-association/pic_10.jpg": "27fe",
	"./gynecology-association/pic_11.jpg": "8979",
	"./gynecology-association/pic_12.jpg": "98ac",
	"./gynecology-association/pic_13.jpg": "df31",
	"./gynecology-association/pic_14.jpg": "c6d6",
	"./gynecology-association/pic_15.jpg": "3759",
	"./gynecology-association/pic_16.jpg": "9ce5",
	"./gynecology-association/pic_17.jpg": "8806",
	"./gynecology-association/pic_18.jpg": "5e7a",
	"./gynecology-association/pic_2.jpg": "5af2",
	"./gynecology-association/pic_3.jpg": "5db3",
	"./gynecology-association/pic_4.jpg": "c507",
	"./gynecology-association/pic_5.jpg": "4c9c",
	"./gynecology-association/pic_6.jpg": "2048",
	"./gynecology-association/pic_7.jpg": "992d",
	"./gynecology-association/pic_8.jpg": "cf71",
	"./gynecology-association/pic_9.jpg": "b3d6",
	"./infectious-hospital/pic_0.jpg": "a4ac",
	"./infectious-hospital/pic_1.jpg": "97ca",
	"./infectious-hospital/pic_10.jpg": "dc4af",
	"./infectious-hospital/pic_11.jpg": "eaaa",
	"./infectious-hospital/pic_12.jpg": "2734",
	"./infectious-hospital/pic_13.jpg": "cb4f",
	"./infectious-hospital/pic_14.jpg": "d58a",
	"./infectious-hospital/pic_15.jpg": "8aa6",
	"./infectious-hospital/pic_16.jpg": "018a",
	"./infectious-hospital/pic_17.jpg": "7683",
	"./infectious-hospital/pic_18.jpg": "174c",
	"./infectious-hospital/pic_19.jpg": "1cfa",
	"./infectious-hospital/pic_2.jpg": "7a34",
	"./infectious-hospital/pic_3.jpg": "e55e",
	"./infectious-hospital/pic_4.jpg": "99fc",
	"./infectious-hospital/pic_5.jpg": "485e",
	"./infectious-hospital/pic_6.jpg": "a7ad",
	"./infectious-hospital/pic_7.jpg": "dd97",
	"./infectious-hospital/pic_8.jpg": "7905",
	"./infectious-hospital/pic_9.jpg": "4d7c",
	"./maternity-chernihiv/pic_0.jpg": "c40f",
	"./maternity-chernihiv/pic_1.jpg": "6650",
	"./maternity-chernihiv/pic_10.jpg": "9afe",
	"./maternity-chernihiv/pic_11.jpg": "e8fd",
	"./maternity-chernihiv/pic_12.jpg": "8b3a",
	"./maternity-chernihiv/pic_13.jpg": "04e1",
	"./maternity-chernihiv/pic_14.jpg": "b08a",
	"./maternity-chernihiv/pic_15.jpg": "7f8c",
	"./maternity-chernihiv/pic_16.jpg": "f6cf",
	"./maternity-chernihiv/pic_17.jpg": "357f",
	"./maternity-chernihiv/pic_18.jpg": "22cb",
	"./maternity-chernihiv/pic_19.jpg": "9f1b",
	"./maternity-chernihiv/pic_2.jpg": "cb12",
	"./maternity-chernihiv/pic_20.jpg": "ec50",
	"./maternity-chernihiv/pic_3.jpg": "04c7",
	"./maternity-chernihiv/pic_4.jpg": "e60b",
	"./maternity-chernihiv/pic_5.jpg": "2126",
	"./maternity-chernihiv/pic_6.jpg": "2466",
	"./maternity-chernihiv/pic_7.jpg": "03ea",
	"./maternity-chernihiv/pic_8.jpg": "6ebb",
	"./maternity-chernihiv/pic_9.jpg": "8244",
	"./maternity-hospital/pic_0.jpg": "11ae",
	"./maternity-hospital/pic_1.jpg": "36f7",
	"./maternity-hospital/pic_10.jpg": "9cb6",
	"./maternity-hospital/pic_11.jpg": "9d72",
	"./maternity-hospital/pic_12.jpg": "2702",
	"./maternity-hospital/pic_13.jpg": "937e",
	"./maternity-hospital/pic_14.jpg": "4963",
	"./maternity-hospital/pic_15.jpg": "a04c",
	"./maternity-hospital/pic_16.jpg": "b3a0",
	"./maternity-hospital/pic_17.jpg": "600c",
	"./maternity-hospital/pic_2.jpg": "4c48",
	"./maternity-hospital/pic_3.jpg": "8fae",
	"./maternity-hospital/pic_4.jpg": "c8a0",
	"./maternity-hospital/pic_5.jpg": "2a92",
	"./maternity-hospital/pic_6.jpg": "85ab",
	"./maternity-hospital/pic_7.jpg": "e727",
	"./maternity-hospital/pic_8.jpg": "5cb9",
	"./maternity-hospital/pic_9.jpg": "1b20",
	"./maternity-lviv/pic_0.jpg": "3dcb",
	"./maternity-lviv/pic_1.jpg": "17be",
	"./maternity-lviv/pic_10.jpg": "261f",
	"./maternity-lviv/pic_11.jpg": "58a8",
	"./maternity-lviv/pic_12.jpg": "ba13",
	"./maternity-lviv/pic_13.jpg": "6c2f",
	"./maternity-lviv/pic_14.jpg": "4b99",
	"./maternity-lviv/pic_15.jpg": "73b7",
	"./maternity-lviv/pic_2.jpg": "dded",
	"./maternity-lviv/pic_3.jpg": "1c3e",
	"./maternity-lviv/pic_4.jpg": "fe59",
	"./maternity-lviv/pic_5.jpg": "4fb4",
	"./maternity-lviv/pic_6.jpg": "190c",
	"./maternity-lviv/pic_7.jpg": "251d",
	"./maternity-lviv/pic_8.jpg": "2b66",
	"./maternity-lviv/pic_9.jpg": "332b",
	"./medical-center/pic_0.jpg": "3c33",
	"./medical-center/pic_1.jpg": "50af",
	"./medical-center/pic_10.jpg": "e3f7",
	"./medical-center/pic_11.jpg": "1989",
	"./medical-center/pic_12.jpg": "b7d5",
	"./medical-center/pic_13.jpg": "8489",
	"./medical-center/pic_14.jpg": "7e1c",
	"./medical-center/pic_15.jpg": "5de7",
	"./medical-center/pic_16.jpg": "1c58",
	"./medical-center/pic_17.jpg": "1a8d",
	"./medical-center/pic_2.jpg": "9550",
	"./medical-center/pic_3.jpg": "9554",
	"./medical-center/pic_4.jpg": "271e",
	"./medical-center/pic_5.jpg": "07b7",
	"./medical-center/pic_6.jpg": "795e",
	"./medical-center/pic_7.jpg": "fd74",
	"./medical-center/pic_8.jpg": "afe6",
	"./medical-center/pic_9.jpg": "a131",
	"./military-hospital/pic_0.jpg": "c1a5",
	"./military-hospital/pic_1.jpg": "664c",
	"./military-hospital/pic_10.jpg": "bb2e",
	"./military-hospital/pic_11.jpg": "d171",
	"./military-hospital/pic_12.jpg": "718b",
	"./military-hospital/pic_13.jpg": "5b77",
	"./military-hospital/pic_14.jpg": "a410",
	"./military-hospital/pic_15.jpg": "482c",
	"./military-hospital/pic_16.jpg": "18ef",
	"./military-hospital/pic_17.jpg": "a787",
	"./military-hospital/pic_2.jpg": "0d6c",
	"./military-hospital/pic_3.jpg": "c196",
	"./military-hospital/pic_4.jpg": "ce464",
	"./military-hospital/pic_5.jpg": "76ba",
	"./military-hospital/pic_6.jpg": "37d8",
	"./military-hospital/pic_7.jpg": "b643",
	"./military-hospital/pic_8.jpg": "81a1",
	"./military-hospital/pic_9.jpg": "d55a",
	"./onco-hospital/pic_0.jpg": "15de",
	"./onco-hospital/pic_1.jpg": "3db9",
	"./onco-hospital/pic_10.jpg": "819d",
	"./onco-hospital/pic_11.jpg": "6640",
	"./onco-hospital/pic_12.jpg": "2dce",
	"./onco-hospital/pic_13.jpg": "4e1b",
	"./onco-hospital/pic_14.jpg": "bd11",
	"./onco-hospital/pic_15.jpg": "8dd1",
	"./onco-hospital/pic_16.jpg": "dba7",
	"./onco-hospital/pic_17.jpg": "8a72",
	"./onco-hospital/pic_18.jpg": "1c09",
	"./onco-hospital/pic_19.jpg": "a807",
	"./onco-hospital/pic_2.jpg": "2d1a",
	"./onco-hospital/pic_20.jpg": "4c7b",
	"./onco-hospital/pic_21.jpg": "de55",
	"./onco-hospital/pic_3.jpg": "d3c1",
	"./onco-hospital/pic_4.jpg": "5899",
	"./onco-hospital/pic_5.jpg": "0f8f",
	"./onco-hospital/pic_6.jpg": "a212",
	"./onco-hospital/pic_7.jpg": "9637",
	"./onco-hospital/pic_8.jpg": "357c",
	"./onco-hospital/pic_9.jpg": "b0eb",
	"./prince-leo/pic_0.jpg": "4555",
	"./prince-leo/pic_1.jpg": "ffdb",
	"./prince-leo/pic_10.jpg": "58e1",
	"./prince-leo/pic_11.jpg": "62b1",
	"./prince-leo/pic_12.jpg": "7f63",
	"./prince-leo/pic_13.jpg": "8432",
	"./prince-leo/pic_14.jpg": "6528",
	"./prince-leo/pic_15.jpg": "ac9b",
	"./prince-leo/pic_16.jpg": "1567",
	"./prince-leo/pic_17.jpg": "17e8",
	"./prince-leo/pic_18.jpg": "a57f",
	"./prince-leo/pic_19.jpg": "928c",
	"./prince-leo/pic_2.jpg": "e041",
	"./prince-leo/pic_20.jpg": "52e3",
	"./prince-leo/pic_3.jpg": "b9e7",
	"./prince-leo/pic_4.jpg": "1e48",
	"./prince-leo/pic_5.jpg": "8f97",
	"./prince-leo/pic_6.jpg": "71e6",
	"./prince-leo/pic_7.jpg": "0028",
	"./prince-leo/pic_8.jpg": "af76",
	"./prince-leo/pic_9.jpg": "faca",
	"./railway-hospital/pic_0.jpg": "fc2c",
	"./railway-hospital/pic_1.jpg": "5573",
	"./railway-hospital/pic_10.jpg": "62c2",
	"./railway-hospital/pic_11.jpg": "6cd9",
	"./railway-hospital/pic_12.jpg": "2c62",
	"./railway-hospital/pic_13.jpg": "0207",
	"./railway-hospital/pic_14.jpg": "b2d4",
	"./railway-hospital/pic_15.jpg": "928e",
	"./railway-hospital/pic_16.jpg": "9a0c",
	"./railway-hospital/pic_17.jpg": "77ba",
	"./railway-hospital/pic_2.jpg": "3eb1",
	"./railway-hospital/pic_3.jpg": "b334",
	"./railway-hospital/pic_4.jpg": "23d3",
	"./railway-hospital/pic_5.jpg": "cda2",
	"./railway-hospital/pic_6.jpg": "e926",
	"./railway-hospital/pic_7.jpg": "c939",
	"./railway-hospital/pic_8.jpg": "c6ae",
	"./railway-hospital/pic_9.jpg": "4344",
	"./regional-center/pic_0.jpg": "1f74",
	"./regional-center/pic_1.jpg": "bf82",
	"./regional-center/pic_10.jpg": "304f",
	"./regional-center/pic_2.jpg": "f448",
	"./regional-center/pic_3.jpg": "f014",
	"./regional-center/pic_4.jpg": "47de",
	"./regional-center/pic_5.jpg": "5b26",
	"./regional-center/pic_6.jpg": "60ce",
	"./regional-center/pic_7.jpg": "d217",
	"./regional-center/pic_8.jpg": "0b3d",
	"./regional-center/pic_9.jpg": "1684",
	"./second-hospital/pic_0.jpg": "3649",
	"./second-hospital/pic_1.jpg": "4046",
	"./second-hospital/pic_10.jpg": "631d",
	"./second-hospital/pic_11.jpg": "dc67",
	"./second-hospital/pic_12.jpg": "c9b2",
	"./second-hospital/pic_13.jpg": "c27b",
	"./second-hospital/pic_2.jpg": "c3fd",
	"./second-hospital/pic_3.jpg": "7435",
	"./second-hospital/pic_4.jpg": "c4d3",
	"./second-hospital/pic_5.jpg": "d48e",
	"./second-hospital/pic_6.jpg": "b514",
	"./second-hospital/pic_7.jpg": "c93c",
	"./second-hospital/pic_8.jpg": "af80",
	"./second-hospital/pic_9.jpg": "40fd",
	"./sixth-lviv/pic_0.jpg": "cb88",
	"./sixth-lviv/pic_1.jpg": "21e2",
	"./sixth-lviv/pic_10.jpg": "09e0",
	"./sixth-lviv/pic_11.jpg": "ebe8",
	"./sixth-lviv/pic_12.jpg": "1782",
	"./sixth-lviv/pic_13.jpg": "ac90",
	"./sixth-lviv/pic_14.jpg": "a8c4",
	"./sixth-lviv/pic_15.jpg": "9950",
	"./sixth-lviv/pic_16.jpg": "1a21",
	"./sixth-lviv/pic_17.jpg": "f178",
	"./sixth-lviv/pic_18.jpg": "0c22",
	"./sixth-lviv/pic_2.jpg": "0bf1",
	"./sixth-lviv/pic_3.jpg": "be7b",
	"./sixth-lviv/pic_4.jpg": "f45e",
	"./sixth-lviv/pic_5.jpg": "087d",
	"./sixth-lviv/pic_6.jpg": "52a4",
	"./sixth-lviv/pic_7.jpg": "9f56",
	"./sixth-lviv/pic_8.jpg": "e203",
	"./sixth-lviv/pic_9.jpg": "8840"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0c13";